import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { ConfirmDialogHost, ErrorBoundary } from '@/components/feedback'
import { ToastHost } from '@/components/ui'

import { AuthProvider } from './auth-provider'
import { QueryProvider } from './query-provider'
import { ThemeProvider } from './theme-provider'

/**
 * Provider composition order matters:
 * the root ErrorBoundary wraps everything so a provider crash still renders a
 * usable screen; Query sits above Auth because the session refresh is
 * cache-aware; Router sits innermost so route-level hooks resolve.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary boundary="app-root">
      <QueryProvider>
        <ThemeProvider>
          <AuthProvider>
            <BrowserRouter>
              {children}
              <ToastHost />
              <ConfirmDialogHost />
            </BrowserRouter>
          </AuthProvider>
        </ThemeProvider>
      </QueryProvider>
    </ErrorBoundary>
  )
}
